<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  strategy: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const isDeleting = ref(false);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

const handleDelete = async () => {
  if (!props.strategy) return;

  isDeleting.value = true;

  try {
    await store.dispatch('strategies/deleteStrategy', props.strategy.id);
    useAlert(t('STRATEGIES.API.DELETE_SUCCESS'));
    close();
  } catch (error) {
    useAlert(t('STRATEGIES.API.ERROR'));
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('STRATEGIES.DELETE.TITLE')"
    type="alert"
    width="sm"
    @close="close"
  >
    <p class="text-sm text-n-slate-11">
      {{ t('STRATEGIES.DELETE.DESCRIPTION') }}
    </p>
    <p v-if="strategy" class="mt-2 font-medium text-n-slate-12">
      "{{ strategy.name }}"
    </p>

    <template #footer>
      <div class="flex justify-end gap-2">
        <Button
          variant="faded"
          color="slate"
          :label="t('STRATEGIES.DELETE.CANCEL')"
          @click="close"
        />
        <Button
          color="ruby"
          :label="t('STRATEGIES.DELETE.CONFIRM')"
          :is-loading="isDeleting"
          @click="handleDelete"
        />
      </div>
    </template>
  </Dialog>
</template>
